import React, { useState } from 'react';
import * as Icon from 'react-feather';
import DataTableWrapper from '../common/dataTable/dataTableWrapper';
import { getDefaultMonthRange, convertDateToLocalDateString } from '../../../core/utils/dateUtils';
import { CalendarRangeField } from '../common/input/inputField';
import { TextInput } from '../../components/inputs';
import { useGetPendingActivationExcel } from '../../../core/hooks/getReports/useGetPendingActivationExcel';
import { downloadExcelFile } from '../../../core/utils/fileUtils';
import usePaginatedFetch from '../../../core/hooks/api/usePaginatedFetch';
import API_ENDPOINTS from '../../../core/constant/API_ENDPOINTS';
import ShowPendingActivationModal from '../common/modals/show-detail-pending-activation-modal';
import { formatDateToMonthDayYear } from '../../../core/utils/dateUtils';

const ClassReservationHistoryReport = () => {
  const [dateRange, setDateRange] = useState<[Date, Date]>(getDefaultMonthRange() as [Date, Date]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string>('');
  const [selectedReservation, setSelectedReservation] = useState<any>();

  const params = dateRange?.length === 2 && dateRange.every(date => date !== null && date !== undefined) ? {
    startDate: convertDateToLocalDateString(dateRange[0]),
    endDate: convertDateToLocalDateString(dateRange[1]),
    email: customerEmail,
  } : null;

  const {
    data: classReservationHistory,
    totalElements,
    first,
    rows,
    onPageChange
  } = usePaginatedFetch(API_ENDPOINTS.pendingActivations, 10, 0, params);

  const { refetchClassReservationHistoryExcel } = useGetPendingActivationExcel(dateRange, customerEmail);

  const columns = [
    { field: "userName", header: "Cliente" },
    { field: "userEmail", header: "Correo del Cliente" },
    { field: "packetName", header: "Nombre del Paquete" },
    { field: "activationDate", header: "Fecha de Activación", body: (rowData: any) => formatDateToMonthDayYear(rowData.activationDate) },
    { field: "quantity", header: "Cantidad de Compra" },
    {
      field: "isActivated",
      header: "Estado de Activación",
      body: (rowData: any) => (
        <div className="d-flex align-items-center justify-content-center">
          {rowData.attended ? (
            <span className="badge badge-success">Activado</span>
          ) : (
            <span className="badge badge-warning">Sin activar</span>
          )}
        </div>
      )
    },
  ];

  const handleShowInfo = (rowData: any) => {
    setSelectedReservation(null);
    setTimeout(() => setSelectedReservation(rowData), 0);
  };

  const handleDownloadExcel = async () => {
    if (dateRange?.length === 2 && dateRange.every(date => date !== null && date !== undefined)) {
      const file = await refetchClassReservationHistoryExcel();
      downloadExcelFile(file, 'class-reservation-history');
    }
  };

  return (
    <div className="page-wrapper page-settings">
      <div className="content">
        <div className="content-page-header content-page-headersplit">
          <h5>Activaciones Pendientes</h5>
        </div>
        <div className="card card-status mb-3">
          <div className="card-head-blk border-bottom-0 pb-0">
            <div className="row align-items-center">
              <div className="col-md-12 d-flex justify-content-end">
                <button
                  className="btn btn-outline-primary rounded-3 mb-3 me-2"
                  onClick={() => {
                    setDateRange(getDefaultMonthRange() as [Date, Date]);
                    setSelectedUserId(null);
                  }}
                >
                  <i className="fa fa-eraser me-2" />
                  Limpiar
                </button>
                <button
                  className="btn btn-primary-admin rounded-3 mb-3 align-items-center d-flex me-2"
                  onClick={handleDownloadExcel}
                >
                  <Icon.FileText className="react-feather-icon me-2" />
                  <span>Descargar como Excel</span>
                </button>
              </div>
              <div className="col-xl-12 col-md-12 d-flex">
                <div className="earning-group gap-3 w-100">
                  <CalendarRangeField
                    label="Seleccionar las fechas de reservas"
                    value={dateRange || [new Date(), new Date()]}
                    onChange={(e: any) => setDateRange(e.value)}
                  />
                  <TextInput
                    label="Escribe el correo del cliente"
                    placeholder="Escribe para buscar..."
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    required={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <DataTableWrapper
            data={classReservationHistory || []}
            lazy={true}
            columns={columns}
            customIcon={Icon.Eye}
            onCustomAction={handleShowInfo}
            rowsPerPage={rows}
            paginator={true}
            first={first}
            totalRecords={totalElements}
            onPageChange={onPageChange}
            showGridlines
            emptyMessage="No se encontraron reservas."
          />
        </div>
      </div>
      <ShowPendingActivationModal selectedActivationData={selectedReservation} />
    </div>
  );
};

export default ClassReservationHistoryReport;